export type StoplightColor = "text-danger" | "text-warning" | "text-success";

// Lower values are worse (activity steps, nutrition score)
export function lowerIsBetter(value: number, redBelow: number, yellowBelow: number): StoplightColor {
  if (value < redBelow) return "text-danger";
  if (value < yellowBelow) return "text-warning";
  return "text-success";
}

// Higher values are worse (glucose)
export function higherIsBetter(value: number, redAbove: number, yellowMin: number): StoplightColor {
  if (value > redAbove) return "text-danger";
  if (value >= yellowMin) return "text-warning";
  return "text-success";
}

// Both extremes are bad (sleep, BMI). Pass yellowBelow = redBelow to disable the low yellow zone.
export function rangeColor(
  value: number,
  redBelow: number, redAbove: number,
  yellowBelow: number, yellowAbove: number
): StoplightColor {
  if (value < redBelow || value > redAbove) return "text-danger";
  if (value < yellowBelow || value > yellowAbove) return "text-warning";
  return "text-success";
}
